(function () {
  var ROOT = '.sz-26-community';
  var SOCIAL_MODAL = '.sz-26-community-social-modal';
  var BODY_MODAL_OPEN = 'sz-26-community-social-modal-open';
  var HTML_MODAL_OPEN = 'sz-26-community-social-modal-open';
  var SCROLLBAR_VAR = '--community-social-modal-scrollbar-w';
  var ACTION_LINK_SELECTOR =
    ROOT +
    ' .event-card__link, ' +
    ROOT +
    ' .contact-card__link, ' +
    ROOT +
    ' .group-card .btn, ' +
    SOCIAL_MODAL +
    ' .social-modal__follow';
  var LOADING_RESET_MS = 2500;
  var SOCIAL_GA4_EVENT = 'community_social_click';
  var ga4MeasurementId = '';
  var ga4ScriptState = 'idle';
  var ga4EventQueue = [];

  function escapeHtmlAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function isValidGa4MeasurementId(value) {
    return /^G-[A-Z0-9]+$/i.test((value || '').trim());
  }

  function discoverGa4MeasurementId() {
    if (ga4MeasurementId) return ga4MeasurementId;

    var section = document.querySelector(
      ROOT + '.sz-26-community-social[data-ga4-measurement-id]'
    );
    if (section) {
      var configuredId = (section.getAttribute('data-ga4-measurement-id') || '').trim();
      if (isValidGa4MeasurementId(configuredId)) {
        ga4MeasurementId = configuredId;
        return ga4MeasurementId;
      }
    }

    var scripts = document.querySelectorAll('script[src*="googletagmanager.com/gtag/js"]');
    for (var i = 0; i < scripts.length; i++) {
      var match = (scripts[i].getAttribute('src') || '').match(/[?&]id=(G-[A-Z0-9]+)/i);
      if (match && match[1]) {
        ga4MeasurementId = match[1];
        return ga4MeasurementId;
      }
    }

    return '';
  }

  function flushGa4EventQueue() {
    ga4EventQueue.splice(0).forEach(function (sendFn) {
      sendFn();
    });
  }

  function ensureCommunityGa4Gtag(onReady) {
    if (typeof onReady !== 'function') return;

    if (ga4ScriptState === 'ready' && typeof gtag === 'function') {
      onReady();
      return;
    }

    var measurementId = discoverGa4MeasurementId();
    if (!measurementId) return;

    ga4EventQueue.push(onReady);
    if (ga4ScriptState === 'loading') return;

    ga4ScriptState = 'loading';
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    gtag('js', new Date());
    gtag('config', measurementId, { send_page_view: false });

    var script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    script.onload = function () {
      ga4ScriptState = 'ready';
      flushGa4EventQueue();
    };
    script.onerror = function () {
      ga4ScriptState = 'idle';
      ga4EventQueue = [];
    };
    document.head.appendChild(script);
  }

  function buildGa4EventParams(payload) {
    var params = { send_to: discoverGa4MeasurementId() };

    if (payload && payload.platform) params.platform = String(payload.platform);
    if (payload && payload.account) params.account = String(payload.account);
    if (payload && payload.link_url) params.link_url = String(payload.link_url);

    if (typeof Shopify !== 'undefined' && Shopify.shop) {
      params.shop_domain = Shopify.shop;
    } else if (window.location.hostname) {
      params.shop_domain = window.location.hostname;
    }

    return params;
  }

  function trackCommunitySocialClick(payload) {
    if (!discoverGa4MeasurementId()) return;

    ensureCommunityGa4Gtag(function () {
      if (typeof gtag !== 'function') return;
      gtag('event', SOCIAL_GA4_EVENT, buildGa4EventParams(payload));
    });
  }

  function initCommunityGa4Preload(root) {
    if (!discoverGa4MeasurementId()) return;

    var scope = getScopeRoot(root);
    if (!scope.querySelector(ROOT + '.sz-26-community-social')) return;

    ensureCommunityGa4Gtag(function () {});
  }

  function initCommunity(root) {
    initExpandSections(root);
    initSocialModals(root);
    initSocialClick(root);
    initGroupAvatars(root);
    initCommunityAnchors(root);
    initReveal(root);
    initCommunityGa4Preload(root);

    if (document.documentElement.dataset.communitySocialAnalyticsInit !== 'true') {
      document.addEventListener(
        'click',
        function (event) {
          var link = event.target.closest(SOCIAL_MODAL + ' .social-modal__follow');
          if (!link) return;

          trackCommunitySocialClick({
            platform: link.getAttribute('data-social-platform') || '',
            account:
              link.getAttribute('data-social-account') ||
              link.getAttribute('data-social-handle') ||
              '',
            link_url: link.getAttribute('href') || ''
          });
        },
        true
      );

      document.documentElement.dataset.communitySocialAnalyticsInit = 'true';
    }
  }

  function getScopeRoot(root) {
    if (!root || root === document) return document;
    if (root.matches && root.matches(ROOT)) return root;
    if (root.querySelector && root.querySelector(ROOT)) {
      return root.querySelector(ROOT);
    }
    return root;
  }

  function findShopifySection(node) {
    if (!node || !node.closest) return null;
    return node.closest('[id^="shopify-section-"]');
  }

  function getCommunityScrollOffset() {
    var styles = getComputedStyle(document.documentElement);
    var stickyHeader = parseFloat(styles.getPropertyValue('--enable-sticky-header')) || 0;
    var headerHeight = (parseFloat(styles.getPropertyValue('--header-height')) || 0) * stickyHeader;
    var stickyAnn = parseFloat(styles.getPropertyValue('--enable-sticky-announcement-bar')) || 0;
    var annHeight = (parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0) * stickyAnn;
    var anchorOffset = parseFloat(styles.getPropertyValue('--anchor-offset')) || 20;
    return headerHeight + annHeight + anchorOffset;
  }

  function parseSamePageHash(href) {
    var value = (href || '').trim();
    if (!value || value === '#') return '';

    if (value.charAt(0) === '#') {
      return value.split('?')[0].split('&')[0];
    }

    try {
      var url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
        return '';
      }
      if (!url.hash) return '';
      return url.hash.split('?')[0].split('&')[0];
    } catch (error) {
      return '';
    }
  }

  function scrollToCommunityTarget(target) {
    if (!target) return;
    var top =
      target.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop);
    window.scrollTo({
      top: Math.max(0, top - getCommunityScrollOffset()),
      behavior: 'smooth'
    });
  }

  function replaceCommunityHash(hash) {
    if (!hash) return;
    try {
      history.replaceState(null, '', window.location.pathname + (window.location.search || '') + hash);
    } catch (error) {
      window.location.hash = hash;
    }
  }

  function cleanCommunityUrlHash() {
    var hash = window.location.hash;
    if (!hash || hash.indexOf('?') === -1) return '';

    var cleanHash = hash.split('?')[0];
    replaceCommunityHash(cleanHash);
    return cleanHash.slice(1);
  }

  function trySamePageHashNav(link, event) {
    if (!link) return false;

    var hash = parseSamePageHash(link.getAttribute('href') || '');
    if (!hash || hash.length <= 1) return false;

    var targetId = hash.slice(1);
    var target = document.getElementById(targetId);
    if (!target) return false;

    if (event) {
      event.preventDefault();
    }

    scrollToCommunityTarget(target);
    replaceCommunityHash(hash);
    return true;
  }

  function initCommunityHashCleanup() {
    if (document.documentElement.dataset.communityHashCleanupInit === 'true') return;

    var cleanedId = cleanCommunityUrlHash();
    if (cleanedId) {
      var cleanedTarget = document.getElementById(cleanedId);
      if (cleanedTarget) {
        requestAnimationFrame(function () {
          var top =
            cleanedTarget.getBoundingClientRect().top +
            (window.pageYOffset || document.documentElement.scrollTop);
          window.scrollTo({
            top: Math.max(0, top - getCommunityScrollOffset()),
            behavior: 'auto'
          });
        });
      }
    }

    window.addEventListener('hashchange', cleanCommunityUrlHash);
    document.documentElement.dataset.communityHashCleanupInit = 'true';
  }

  function initCommunityAnchors(root) {
    var scope = getScopeRoot(root);
    if (!scope.querySelectorAll) return;

    scope.querySelectorAll(ROOT + ' a[href^="#"]').forEach(function (link) {
      if (link.dataset.communityAnchorInit === 'true') return;

      link.addEventListener('click', function (event) {
        trySamePageHashNav(link, event);
      });

      link.dataset.communityAnchorInit = 'true';
    });
  }

  function initReveal(root) {
    var scope = getScopeRoot(root);
    var revealEls = scope.querySelectorAll
      ? scope.querySelectorAll(ROOT + ' .js-reveal')
      : [];

    revealEls.forEach(function (el) {
      if (el.dataset.communityRevealInit === 'true') return;

      var section = el.closest(ROOT);
      if (section && section.classList.contains('reveal-off')) {
        el.classList.add('animate-in');
        el.dataset.communityRevealInit = 'true';
        return;
      }

      if (!('IntersectionObserver' in window)) {
        el.classList.add('animate-in');
        el.dataset.communityRevealInit = 'true';
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -20px 0px' }
      );

      observer.observe(el);
      el.dataset.communityRevealInit = 'true';
    });
  }

  function revealExpandedCards(section) {
    if (!section) return;
    section.querySelectorAll('[data-community-more].js-reveal:not(.animate-in)').forEach(function (el) {
      el.classList.add('animate-in');
    });
  }

  function initExpandSection(section) {
    if (!section || section.dataset.communityExpandInit === 'true') return;
    if (!section.matches || !section.matches(ROOT + '[data-community-expand]')) return;

    var toggle = section.querySelector('[data-community-toggle]');
    if (!toggle) return;

    var moreCards = section.querySelectorAll('[data-community-more]');
    if (!moreCards.length) {
      var foot = toggle.closest('.section-foot');
      if (foot) foot.hidden = true;
      section.classList.remove('is-collapsed');
      section.dataset.communityExpandInit = 'true';
      return;
    }

    var label = toggle.querySelector('.events-toggle__label');
    var expandLabel = toggle.getAttribute('data-label-expand') || 'View all';
    var collapseLabel = toggle.getAttribute('data-label-collapse') || 'Show less';

    toggle.addEventListener('click', function () {
      var willExpand = section.classList.contains('is-collapsed');

      section.classList.toggle('is-collapsed', !willExpand);
      section.classList.toggle('is-expanded', willExpand);
      toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');

      if (label) {
        label.textContent = willExpand ? collapseLabel : expandLabel;
      }

      if (willExpand) {
        revealExpandedCards(section);
      }
    });

    section.dataset.communityExpandInit = 'true';
  }

  function initExpandSections(root) {
    var scope = getScopeRoot(root);
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll(ROOT + '[data-community-expand]').forEach(initExpandSection);
  }

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function lockPageScroll() {
    document.documentElement.style.setProperty(SCROLLBAR_VAR, getScrollbarWidth() + 'px');
    document.documentElement.classList.add(HTML_MODAL_OPEN);
    document.body.classList.add(BODY_MODAL_OPEN);
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove(HTML_MODAL_OPEN);
    document.body.classList.remove(BODY_MODAL_OPEN);
    document.documentElement.style.removeProperty(SCROLLBAR_VAR);
  }

  function bindSocialModal(modal) {
    if (!modal || modal.dataset.communitySocialInit === 'true') return;

    var modalTitle = modal.querySelector('[data-social-modal-title]');
    var modalIcon = modal.querySelector('[data-social-modal-icon]');
    var modalList = modal.querySelector('[data-social-modal-list]');
    var followArrowSvg =
      '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true"><path d="M2.70834 6.49992H10.2917M6.50001 10.2916L10.2917 6.49992L6.50001 2.70825" stroke="currentColor" stroke-width="1.35417" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    if (!modalTitle || !modalIcon || !modalList) return;

    function closeModal() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      unlockPageScroll();
      modalList.innerHTML = '';
    }

    function openModal(config) {
      modalTitle.textContent = config.platform || '';
      modalIcon.innerHTML = config.iconSrc
        ? '<img src="' + config.iconSrc + '" alt="" />'
        : '';

      modalList.innerHTML = (config.accounts || [])
        .map(function (account, index) {
          var name = account.name || '';
          var handle = account.handle || '';
          var url = account.url || '#';

          return (
            '<article class="social-modal__account">' +
            '<span class="social-modal__index">' + (index + 1) + '</span>' +
            '<div class="social-modal__account-info">' +
            '<p class="social-modal__account-name">' + name + '</p>' +
            '<p class="social-modal__account-handle">' + handle + '</p>' +
            '</div>' +
            '<a class="social-modal__follow" href="' + escapeHtmlAttr(url) + '" target="_blank" rel="noopener noreferrer" data-social-platform="' +
            escapeHtmlAttr(config.platform) +
            '" data-social-account="' +
            escapeHtmlAttr(name) +
            '" data-social-handle="' +
            escapeHtmlAttr(handle) +
            '">Follow ' +
            followArrowSvg +
            '</a>' +
            '</article>'
          );
        })
        .join('');

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      lockPageScroll();
    }

    modal.__communityOpenModal = openModal;
    modal.__communityCloseModal = closeModal;

    modal.querySelectorAll('[data-social-modal-close]').forEach(function (trigger) {
      trigger.addEventListener('click', closeModal);
    });

    modal.dataset.communitySocialInit = 'true';
  }

  function initSocialModals(root) {
    var scope = getScopeRoot(root);
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll(SOCIAL_MODAL + '[data-social-modal]').forEach(bindSocialModal);
  }

  function parseSocialConfig(card) {
    var raw = card.getAttribute('data-social');
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function openExternalLink(url) {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function activateLoading(el, resetMs) {
    if (!el || el.classList.contains('is-loading')) return false;

    el.classList.add('is-loading');
    el.setAttribute('aria-busy', 'true');

    if (resetMs > 0) {
      window.setTimeout(function () {
        deactivateLoading(el);
      }, resetMs);
    }

    return true;
  }

  function deactivateLoading(el) {
    if (!el) return;
    el.classList.remove('is-loading');
    el.removeAttribute('aria-busy');
  }

  function opensInNewTab(link) {
    return link.target === '_blank' || link.getAttribute('target') === '_blank';
  }

  function isMailtoLink(link) {
    var href = (link.getAttribute('href') || '').trim();
    return /^mailto:/i.test(href);
  }

  function openContactMailto(href) {
    if (!href) return;

    if (window.top !== window.self) {
      try {
        window.top.location.href = href;
      } catch (error) {
        window.open(href, '_blank', 'noopener,noreferrer');
      }
      return;
    }

    window.location.href = href;
  }

  function initContactEmailLinks() {
    if (document.documentElement.dataset.communityContactEmailInit === 'true') return;

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest(ROOT + ' .contact-card__link[data-contact-mailto]');
        if (!link || link.classList.contains('is-loading')) return;

        if (window.top === window.self) return;

        event.preventDefault();
        openContactMailto(link.getAttribute('href') || '');
      },
      true
    );

    document.documentElement.dataset.communityContactEmailInit = 'true';
  }

  function initActionLinkLoading() {
    if (document.documentElement.dataset.communityLinkLoadingInit === 'true') return;

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest(ACTION_LINK_SELECTOR);
        if (!link) return;

        if (link.classList.contains('is-loading')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (isMailtoLink(link)) return;

        activateLoading(link, opensInNewTab(link) ? LOADING_RESET_MS : 0);
      },
      true
    );

    document.documentElement.dataset.communityLinkLoadingInit = 'true';
  }

  function handleFollowClick(button) {
    var card = button.closest(ROOT + ' .social-card');
    if (!card) return;

    var config = parseSocialConfig(card);
    if (!config) return;

    var accounts = Array.isArray(config.accounts) ? config.accounts : [];
    var validAccounts = accounts.filter(function (account) {
      return account && account.url;
    });

    if (!validAccounts.length) return;

    var sectionWrap = findShopifySection(button);
    var modal = sectionWrap
      ? sectionWrap.querySelector(SOCIAL_MODAL + '[data-social-modal]')
      : document.querySelector(SOCIAL_MODAL + '[data-social-modal]');

    var singleModal = modal && modal.dataset.socialModalSingle === 'true';
    var platform = config.platform || '';

    if (validAccounts.length === 1 && !singleModal) {
      var directAccount = validAccounts[0];
      trackCommunitySocialClick({
        platform: platform,
        account: directAccount.name || directAccount.handle || '',
        link_url: directAccount.url || ''
      });
      activateLoading(button, LOADING_RESET_MS);
      openExternalLink(directAccount.url);
      return;
    }

    if (!modal) return;

    if (modal.dataset.communitySocialInit !== 'true') {
      bindSocialModal(modal);
    }

    if (typeof modal.__communityOpenModal === 'function') {
      modal.__communityOpenModal({
        platform: platform,
        iconSrc: config.iconSrc,
        accounts: validAccounts
      });
    }
  }

  function initSocialClick(root) {
    var scope = getScopeRoot(root);
    if (!scope.querySelectorAll) return;

    scope.querySelectorAll(ROOT + ' .social-card__btn').forEach(function (button) {
      if (button.dataset.communityFollowInit === 'true') return;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (button.classList.contains('is-loading')) return;
        handleFollowClick(button);
      });
      button.dataset.communityFollowInit = 'true';
    });
  }

  function initGroupAvatars(root) {
    var scope = getScopeRoot(root);
    if (!scope.querySelectorAll) return;

    var maxVisible = 4;
    scope.querySelectorAll(ROOT + ' .group-card__avatars').forEach(function (container) {
      if (container.dataset.communityAvatarsInit === 'true') return;

      var imgs = Array.prototype.slice.call(container.querySelectorAll('img'));

      if (imgs.length <= maxVisible) {
        container.dataset.communityAvatarsInit = 'true';
        return;
      }

      imgs.slice(maxVisible).forEach(function (img) {
        img.remove();
      });

      if (!container.querySelector('.group-card__avatars-more')) {
        var more = document.createElement('span');
        more.className = 'group-card__avatars-more';
        more.setAttribute('aria-hidden', 'true');
        container.appendChild(more);
      }

      container.dataset.communityAvatarsInit = 'true';
    });
  }

  function initEscapeClose() {
    if (document.documentElement.dataset.communityEscapeInit === 'true') return;

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(SOCIAL_MODAL + '.is-open[data-social-modal]').forEach(function (modal) {
        if (typeof modal.__communityCloseModal === 'function') {
          modal.__communityCloseModal();
        }
      });
    });

    document.documentElement.dataset.communityEscapeInit = 'true';
  }

  initEscapeClose();
  initCommunityHashCleanup();
  initContactEmailLinks();
  initActionLinkLoading();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCommunity(document);
    });
  } else {
    initCommunity(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initCommunity(event.target);
  });
})();
